import { IApplicationState } from '../types/redux';

export const selectAbUseExperiments = (state: IApplicationState) => state.abUseExperiments;
